import { API_BASE_URL, API_HEADERS } from '../config';

export const shipService = {
  updateShipNick: async (shipId: number | string, nick: string) => {
    const token = sessionStorage.getItem('corvus_token');
    
    if (!token) {
      throw new Error('No se encontró token de autenticación');
    }

    const headers = {
      ...API_HEADERS,
      'Authorization': token,
      'Content-Type': 'application/json'
    };
    const body = JSON.stringify({ nick });
    const candidates = [
      { method: 'PUT', url: `${API_BASE_URL}/flota/nave/${shipId}/nick` },
      { method: 'PATCH', url: `${API_BASE_URL}/flota/nave/${shipId}/nick` },
      { method: 'PUT', url: `${API_BASE_URL}/flota/naves/${shipId}/nick` },
      { method: 'PATCH', url: `${API_BASE_URL}/flota/naves/${shipId}/nick` },
      { method: 'PUT', url: `${API_BASE_URL}/flota/nave/${shipId}` },
      { method: 'PATCH', url: `${API_BASE_URL}/flota/nave/${shipId}` },
      { method: 'PUT', url: `${API_BASE_URL}/flota/naves/${shipId}` },
      { method: 'PATCH', url: `${API_BASE_URL}/flota/naves/${shipId}` },
    ];

    try {
      let lastError = 'No se pudo actualizar el nombre de la nave';

      for (const candidate of candidates) {
        const response = await fetch(candidate.url, {
          method: candidate.method,
          headers,
          body
        });

        if (response.ok) {
          const contentType = response.headers.get('content-type') || '';
          if (contentType.includes('application/json')) {
            return response.json();
          }
          return { success: true };
        }

        const errorText = await response.text();
        lastError = `Error ${response.status}: ${errorText}`;

        // Para errores diferentes a 404/405 no seguimos probando variantes.
        if (response.status !== 404 && response.status !== 405) {
          break;
        }
      }

      throw new Error(lastError);
    } catch (error) {
      throw error;
    }
  }
}; 